import { render, staticRenderFns } from "./administrator.vue?vue&type=template&id=6b88897f&scoped=true&"
import script from "./administrator.vue?vue&type=script&lang=js&"
export * from "./administrator.vue?vue&type=script&lang=js&"
import style0 from "./administrator.vue?vue&type=style&index=0&id=6b88897f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88897f",
  null
  
)

export default component.exports